import type { PublisherFilterState } from '../../../types/managePublishers';
import { useTranslation } from '../../../i18n/useTranslation';

interface Props {
  filters: PublisherFilterState;
  onChange: (patch: Partial<PublisherFilterState>) => void;
}

export default function PublisherListFilters({ filters, onChange }: Props) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center gap-3 mb-3">
      <input
        type="search"
        value={filters.q ?? ''}
        onChange={(e) => onChange({ q: e.target.value || undefined, page: 1 })}
        placeholder={t('App.Admin.Publishers.PublisherListFilters.SearchPlaceholder')}
        className="border border-neutral-300 rounded px-3 py-2 text-sm w-72"
        aria-label={t('App.Admin.Publishers.PublisherListFilters.SearchAriaLabel')}
      />

      <select
        value={filters.isActive === undefined ? '' : String(filters.isActive)}
        onChange={(e) => onChange({
          isActive: e.target.value === '' ? undefined : e.target.value === 'true',
          page: 1,
        })}
        className="border border-neutral-300 rounded px-2 py-2 text-sm"
        aria-label="Active filter"
      >
        <option value="">{t('App.Admin.Publishers.PublisherListFilters.ActiveAny')}</option>
        <option value="true">{t('App.Admin.Publishers.PublisherListFilters.ActiveYes')}</option>
        <option value="false">{t('App.Admin.Publishers.PublisherListFilters.ActiveNo')}</option>
      </select>

      <select
        value={filters.isDrmEnabled === undefined ? '' : String(filters.isDrmEnabled)}
        onChange={(e) => onChange({
          isDrmEnabled: e.target.value === '' ? undefined : e.target.value === 'true',
          page: 1,
        })}
        className="border border-neutral-300 rounded px-2 py-2 text-sm"
        aria-label="DRM filter"
      >
        <option value="">{t('App.Admin.Publishers.PublisherListFilters.DrmAny')}</option>
        <option value="true">{t('App.Admin.Publishers.PublisherListFilters.DrmEnabled')}</option>
        <option value="false">{t('App.Admin.Publishers.PublisherListFilters.DrmDisabled')}</option>
      </select>
    </div>
  );
}
